import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "abg-category-mapping-component" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ABG Category Mapping ")
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { style: {"margin-top":"16px"} }, "ABG Category Mapping Management", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Upload CSV ")
const _hoisted_5 = {
  key: 0,
  style: {"padding-top":"7.5px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Upload File")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "ant-pro-table-list-toolbar-container",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-left" }, [
      /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-title" }, "ABG Category Mapping Table")
    ])
  ])
], -1)
const _hoisted_8 = {
  key: 1,
  style: {"font-style":"italic","color":"gray"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_extension_table_outlined = _resolveComponent("extension-table-outlined")
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")
  const _component_upload_outlined = _resolveComponent("upload-outlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")
  const _component_a_descriptions = _resolveComponent("a-descriptions")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { href: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_extension_table_outlined),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "CSV" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": _ctx.fileList,
                  "before-upload": _ctx.beforeUpload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_outlined),
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    (_ctx.csvFileLabel !== null && _ctx.csvFileLabel !== undefined && _ctx.csvFileLabel.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.csvFileLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["file-list", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  loading: _ctx.loadingUpload,
                  onClick: _ctx.uploadCsv
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      style: {"margin-top":"16px"},
      "body-style": { padding: 0 }
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        _createVNode(_component_a_table, {
          size: 'small',
          loading: _ctx.loadingTable,
          columns: _ctx.columns,
          "data-source": _ctx.rows,
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          image: _withCtx(({ record }) => [
            _createVNode("a", {
              href: record.signed_image,
              target: "_blank",
              style: {"float":"left"}
            }, [
              _createVNode("img", {
                src: record.signed_image,
                alt: record.name,
                style: {"max-width":"100px","max-height":"100px","display":"block"}
              }, null, 8, ["src", "alt"])
            ], 8, ["href"])
          ]),
          viewMore: _withCtx(({ record }) => [
            (!record.deleteLoading)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "#",
                  style: {"color":"red"},
                  onClick: _withModifiers(($event: any) => (_ctx.deleteRow(record)), ["prevent"])
                }, "Delete", 8, ["onClick"]))
              : _createCommentVNode("", true),
            (record.deleteLoading)
              ? (_openBlock(), _createBlock("a", _hoisted_8, "Deleting..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = $event)),
      width: "1000px",
      footer: false,
      title: "Viewing Record"
    }, {
      default: _withCtx(() => [
        (_ctx.viewingRow !== null)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 0,
              title: "Record Information",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "PLU" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.plu), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Company Code" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.company_code), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Store Code" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.store_code), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "SKU" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.sku), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Product ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.product_id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Description" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.description), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Variant Options" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.variant_options), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Images String" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.images), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Is Chilled" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.is_chilled), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Is Frozen" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.is_frozen), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Weight" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.weight), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Length" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.length), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Width" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.width), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Height" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.height), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Is Age Gated" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.is_age_gated), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Non Halal" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.non_halal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Brand Name" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.brand_name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Max Cart" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.max_cart), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Unit Count" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.unit_count), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Unit Type" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.unit_type), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Is Perishable" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.is_perishable), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Product Origin" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.product_origin), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Product Grade" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.product_grade), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Product Size" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.product_size), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "Is Published" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.viewingRow.is_published), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}